// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popup_wrapper__3o6bE","rootPopper":"Popup_rootPopper__2zWjW"};